<template>
  <section>
    <div>
      <!--
      <p>clickzip.de möchte Cookies verwenden, um Ihnen ein optimales Nutzungserlebnis zu bieten. Erst durch das Akzepieren der Cookienutzung werden Cookies gesetzt. Weitere Details dazu finden Sie in unserer <a href="#">Datenschutzerklärung</a> und insbesondere in unserer <a href="#">Cookie Policy</a>.</p>
      <button @click="acceptCookies()" v-ripple.mouseover="'rgba(255, 255, 255, 0.1)'">Cookienutzung akzeptieren</button>
      -->
      <p>clickzip.de möchte <strong>Cookies</strong> zu Tracking- und Analysezwecken von Google Analytics verwenden. Diese Cookies werden erst gesetzt, wenn Sie die Nutzung von Google Analytics und Cookies hiermit explizit akzeptieren. Details dazu finden Sie in unserer <a href="#">Datenschutzerklärung</a>. Möchten Sie keine Cookies von Drittanbietern wie Google Analytics zulassen, können Sie das Setzen von Cookies <button @click="deny()" class="deny">ablehen</button>.</p>
      <!-- <p>clickzip.de möchte <strong>Google Analytics</strong> zur Analyse verwenden, um Ihnen ein optimales Nutzungserlebnis zu bieten. Akzeptieren Sie die Nutzung von Google Analytics, werden Cookies zu Analysezwecken gesetzt. Technisch notwendige Cookies können unabhängig davon gesetzt werden. Weitere Details dazu finden Sie in unserer <a href="#">Datenschutzerklärung</a> und insbesondere in unserer <a href="#">Cookie Policy</a>. Möchten Sie keine Cookies von Drittanbietern wie Google Analytics zulassen, können Sie diesen Hinweis ignorieren oder das Setzen von Cookies <button @click="deny()" class="deny">ablehen</button>.</p> -->
      <button @click="acceptCookies()" v-ripple.mouseover="'rgba(255, 255, 255, 0.1)'">Ich akzeptiere</button>
    </div>
  </section>
</template>
<script>
export default {
  name: 'CookieBanner',
  methods: {
    acceptCookies: function () {
      this.$root.cookieAccepted = true
    },
    deny: function () {
      this.$root.cookieDenied = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/css/variables.scss";
section {
  position: fixed;
  z-index: 9;
  bottom: 0;
  right: 0;
  max-width: 100%;
  div {
    animation-name: fadeIn;
    animation-duration: 1s;
    animation-iteration-count: 1;
    background: #2d2d2d;
    border-radius: 15px;
    color: #fff;
    margin: 0 10px 10px 10px;
    padding: 20px 20px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    display: flex;
    flex-wrap: wrap;
    p {
      margin: 0 0 15px 0;
      color: #b9b9b9;
      .deny {
        -webkit-appearance: none;
        position: relative;
        overflow: hidden;
        outline: none;
        background: transparent;
        background: none;
        border: none;
        text-decoration: underline;
        font-size: 16px;
        font-family: $secondaryFont;
        font-weight: 400;
        color: #b9b9b9;
        display: inline-block;
        align-self: left;
        align-self: start;
        align-self: flex-start;
        margin: 0;
        padding: 0;
        border-radius: 0;
        &:before {
          display: none;
        }
      }
      strong {
        color: #fff;
        font-weight: $secondaryFontBold;
      }
      a {
        color: #b9b9b9;
        text-decoration: underline;
      }
    }
    button {
      -webkit-appearance: none;
      position: relative;
      overflow: hidden;
      font-family: $secondaryFont;
      font-weight: $secondaryFontBold;
      padding:10px 30px 10px 29px;
      outline: none;
      border: 3px solid #fff;
      color: #fff;
      line-height: 1;
      border-radius: 25px;
      background: transparent;
      background: none;
      font-size: 16px;
      white-space: nowrap;
      transform: translate3d(0,0,0); // ripple bug
      align-self: right;
      align-self: end;
      align-self: flex-end;
      &:before {
        content:'';
        display:inline-block;
        background-position:center center;
        background-repeat:no-repeat;
        margin-right:6px;
        position: relative;
        top: 2px;
        background-image:url('../assets/img/icons/buttons/checkwhite.svg');
        width: 18px;
        height: 14px;
      }
      &::-moz-focus-inner {
        border: 0;
        padding: 0;
      }
    }
  }
}
@media (min-width: 767px) {
  section {
    div {
      margin: 0 10px 10px 112px;
      flex-wrap: nowrap;
      p {
        margin: 0;
        width: 80%;
        width: calc(100% - 232px);
      }
      button {
        font-size:18px;
        margin-left: 20px;
      }
      button:before {
        margin-right:8px;
        width:20px;
        height:16px;
      }
    }
  }
}
@media (min-width: 1180px) {
  section {
    div {
      margin: 0 15px 15px 295px;
    }
  }
  .closed-large-overview {
    section {
      div {
        margin: 0 15px 15px 117px;
      }
    }
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
